var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=7dcad0e4&
// module id = null
// module chunks = 